<!--Bar for screens loaded in non-Express environments (i.e. Incode shell)-->
<!-- TODO For Angular update, use Forge toolbar instead of mat-toolbar -->
@if (isEmbedded) {
@if (showBackBar) {
<mat-toolbar>
    <forge-icon-button (click)="back()">
        <button telemetry="Submission-Back">
            <forge-icon name="arrow_back"></forge-icon>
        </button>
    </forge-icon-button>
</mat-toolbar>
}
} @else {
@if (showERPProBanner) {
<forge-banner theme="warning" persistent="true">
    <forge-icon slot="icon" name="notifications"></forge-icon>
    <div>WebLauncher is being replaced by the new ERP Pro App. Please click <a href="{{getERPProDownloadUrl}}">here to
            download and install it.</a></div>
    <forge-button slot="button" variant="outlined" (click)="openLearnMoreERPPro()">Learn more...</forge-button>
</forge-banner>
}
<forge-app-bar id="app-bar" [ngClass]="omniBarClasses">
    @if (authenticated && !isVendorUser) {
    <forge-icon-button slot="start" #omnibarMenu id="omnibarMenu" [disabled]="menuDisabled" (click)="toggleMenu()"
        aria-keyshortcuts="Control+F2" aria-label="toggle navigation menu">
        <forge-icon name="menu"></forge-icon>
        <forge-tooltip>Open menu (Ctrl + F2)</forge-tooltip>
    </forge-icon-button>
    }
    <a slot="logo" [href]="defaultAppUrl" tabindex="0" aria-label="Link to My Dashboard">
        <forge-icon name="tyler_talking_t_logo"></forge-icon>
    </a>
    <a tabindex="0" (click)="reload()" role="link" slot="title" attr.aria-label="reload {{omniTitle()}}"
        telemetry="Submission-Reload">
        <div class="forge-typography--heading4 header-text">{{omniTitle()}}</div>
    </a>
    @if (authenticated && allowSearch) {
    <omni-search slot="center" [commandKey]="commandKey"></omni-search>
    }
    @if (!isVendorUser) {
    @if (authenticated)
    {
    <conn-group-action slot="end">
    </conn-group-action>
    }
    @if (isFeatureFlagged)
    {
    <ideas-action slot="end">
    </ideas-action>
    }
    @if (authenticated && showTylerAssistantFeatureFlag())
    {
    <smart-pulse slot="end">
    </smart-pulse>
    }
    <support-chat slot="end">
    </support-chat>
    <help-menu slot="end">
    </help-menu>
    <nine-box slot="end">
    </nine-box>
    }
    @if (authenticated) {
    <profile-menu slot="end">
    </profile-menu>
    }
</forge-app-bar>
@if (isProvisional) {
<forge-inline-message class="provisional">
    <div>This is a provisional database. Any transactions will not impact live data.</div>
</forge-inline-message>
}
}
